function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#243165;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16c8.8,0,16-7.2,16-16S24.8,0,16,0z M23.5,23.7c0,0-0.1,0-0.2,0 c-5.7,0-11.3,0-17,0c-0.1,0-0.3,0-0.4,0c0.1-2.9,1.2-6.6,6.3-7.1c0.5,1,1.1,2,1.6,3c0.1,0,0.1,0,0.2,0c0.1-0.2,0.2-0.5,0.3-0.7 c0.1-0.3,0.3-0.6,0.3-0.9c0-0.3-0.3-0.5-0.4-0.9c0.6,0,1.1,0,1.6,0c0,0,0,0.1,0,0.1c-0.8,0.5-0.3,1.2-0.2,1.8 c0.1,0.2,0.2,0.4,0.3,0.6c0.1-0.2,0.3-0.4,0.4-0.6c0.4-0.7,0.8-1.5,1.2-2.2c0-0.1,0.1-0.2,0.2-0.3c0.9,0.3,1.7,0.6,2.6,0.9 c1.6,0.6,2.6,1.8,3,3.4c0.2,0.8,0.3,1.7,0.5,2.6C23.8,23.5,23.6,23.6,23.5,23.7z M26.6,12.4c0,0.8-0.2,1.1-1.1,1.1 c-0.4,0-1-0.1-1.2,0.1c-0.2,0.2-0.1,0.8-0.2,1.2c0,0.3-0.1,0.6-0.1,0.9c-0.7-0.7-1.2-1.3-1.9-1.9c-0.3-0.2-0.7-0.4-1-0.4 c-1.3,0-2.6,0-3.9,0c-0.3,1.2-1.1,1.9-2.1,2.5c-0.7,0.4-1.3-0.1-1.8-0.5c-0.8-0.7-1.5-1.4-1.6-2.6c0-0.3-0.2-0.5-0.3-0.8 c-0.2-0.5-0.3-0.9,0.2-1.3c0.1,0,0.1-0.2,0.1-0.3c0.1-1.3,0.6-2.1,1.5-2.6c0-0.8,0-1.7,0-2.5c0-0.8,0.2-1,1-1c3.8,0,7.6,0,11.4,0 c0.8,0,1,0.3,1,1c0,1.3,0,2.6,0,3.9C26.6,10.4,26.6,11.4,26.6,12.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M17.3,9.5c0.1,0.3,0.1,0.6,0.2,1c0,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.1,0.4,0.1,0.6c-0.1,0.2-0.1,0.5-0.2,0.7 c0,0.2-0.1,0.3-0.2,0.5c2.8,0,5.6,0,8.4,0c0-2.5,0-5,0-7.6c-4,0-7.9,0-11.9,0c0,0.8,0,1.7,0,2.5c0,0,0.1,0,0.1,0 C15.3,7.5,16.8,7.9,17.3,9.5z"
}));

var SvgConsultor = function SvgConsultor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConsultor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Consultor.0c0aee3b.svg";
export { ForwardRef as ReactComponent };